package pl.nickers.match3.ecs

internal class GhostBombSystem : BaseSystem() {
    private lateinit var ghostBombMapper: ComponentMapper<GhostBombComponent>
    private lateinit var fusedBombMapper: ComponentMapper<FusedBombComponent>

    override fun initialize() {
        ghostBombMapper = world.mapper()
        fusedBombMapper = world.mapper()
    }

    override fun processSystem() {
        val board = world.boardState() ?: return
        if (board.phase != GamePhase.RESOLVE || board.currentSubphase != ResolveSubphase.GHOST) return
        val ghostBombs = world.getEntitiesForAspect(Aspect.all(GhostBombComponent::class)).toList()
        if (ghostBombs.isEmpty()) return
        for (ghost in ghostBombs) {
            fusedBombMapper.set(ghost, FusedBombComponent())
        }
        board.didWork = true
    }
}
